import { ALLERGY_CARD_SEO } from "../../features/allergy-card/seoContent";
import type { SupportedLocale } from "../../lib/localeRoutes";

export function AllergyCardGuide({ locale }: { locale: SupportedLocale }) {
  const copy = ALLERGY_CARD_SEO[locale];
  return (
    <section aria-labelledby="allergy-card-guide-title" className="pt-10 sm:pt-12" data-allergy-card-guide>
      <div className="max-w-3xl">
        <h2 id="allergy-card-guide-title" className="text-2xl font-semibold tracking-tight">{copy.heading}</h2>
        <p className="mt-3 text-sm leading-7 text-muted-foreground">{copy.introduction}</p>
      </div>
      <div className="mt-8 grid gap-7 sm:grid-cols-2 sm:gap-10">
        <div>
          <h3 className="text-base font-semibold">{copy.translationHeading}</h3>
          <p className="mt-2 text-sm leading-7 text-muted-foreground">{copy.translationText}</p>
        </div>
        <div>
          <h3 className="text-base font-semibold">{copy.downloadHeading}</h3>
          <p className="mt-2 text-sm leading-7 text-muted-foreground">{copy.downloadText}</p>
        </div>
      </div>
      <div className="mt-10">
        <h2 className="text-xl font-semibold tracking-tight">{copy.faqHeading}</h2>
        <div className="mt-4 divide-y divide-border border-y border-border">
          {copy.questions.map(({ question, answer }) => (
            <details key={question} className="group">
              <summary className="min-h-12 cursor-pointer py-4 pr-4 text-sm font-medium leading-6 marker:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2">{question}</summary>
              <p className="max-w-3xl pb-5 text-sm leading-7 text-muted-foreground">{answer}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
